import { render, staticRenderFns } from "./rotateSurfaceButton.vue?vue&type=template&id=09b08b96&"
import script from "./rotateSurfaceButton.vue?vue&type=script&lang=ts&"
export * from "./rotateSurfaceButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports